import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPalette = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M8 2C4.687 2 2 4.687 2 8s2.687 6 6 6c.553 0 1-.447 1-1 0-.26-.1-.493-.26-.673-.153-.174-.253-.407-.253-.66 0-.554.446-1 1-1h1.18c1.84 0 3.333-1.494 3.333-3.334C14 4.387 11.313 2 8 2zM4.333 8c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .554 0 1 .447 1 1 0 .553-.446 1-1 1zm2-2.667c-.553 0-1-.446-1-1 0-.553.447-1 1-1 .554 0 1 .447 1 1 0 .554-.446 1-1 1zm3.334 0c-.554 0-1-.446-1-1 0-.553.446-1 1-1 .553 0 1 .447 1 1 0 .554-.447 1-1 1zm2 2.667c-.554 0-1-.447-1-1 0-.553.446-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1z"
	})
});
export default SvgIconPalette;
